// extracted by mini-css-extract-plugin
export default {"menuBlock":"lE-z","title":"mE-z","nav":"nE-z","flexCell":"oE-z","facetLink":"pE-z"};